import { useMsal } from "@azure/msal-react";
import { Card } from "../components/Card.js";
import { Badge } from "../components/Badge.js";

export function AccountPage() {
  const { instance, accounts } = useMsal();
  const account = accounts[0];

  if (!account) {
    return (
      <Card title="Account">
        <p className="text-sm text-slate-600">Not signed in.</p>
      </Card>
    );
  }

  const claims = (account.idTokenClaims ?? {}) as Record<string, unknown>;
  const roles = Array.isArray(claims.roles)
    ? (claims.roles as string[])
    : [];

  return (
    <Card title="Account">
      <dl className="grid gap-2 text-sm">
        <Row label="Email">{account.username}</Row>
        <Row label="Name">{account.name ?? "—"}</Row>
        <Row label="Tenant id">
          <code className="text-xs">{account.tenantId}</code>
        </Row>
        <Row label="Object id">
          <code className="text-xs">{account.localAccountId}</code>
        </Row>
        <Row label="Roles">
          {roles.length === 0 ? (
            <span className="text-slate-400">None</span>
          ) : (
            <div className="flex flex-wrap gap-1">
              {roles.map((r) => (
                <Badge key={r} tone="blue">
                  {r}
                </Badge>
              ))}
            </div>
          )}
        </Row>
      </dl>
      <div className="mt-4">
        <button
          type="button"
          onClick={() => {
            void instance.logoutRedirect();
          }}
          className="rounded-md border border-slate-300 px-3 py-1.5 text-sm hover:bg-slate-50"
        >
          Sign out
        </button>
      </div>
    </Card>
  );
}

function Row({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <div className="grid grid-cols-[8rem_1fr] gap-3">
      <dt className="text-slate-500">{label}</dt>
      <dd className="text-slate-800">{children}</dd>
    </div>
  );
}
